module.exports = __webpack_public_path__ + "static/media/certificateofconformityback.24e73198.jpg";